module.exports = __webpack_public_path__ + "img/capitalchain.e43c90f1.svg";